import { type SliderRailSlotProps } from '@mui/base'
import { clsx } from 'clsx'
import { forwardRef } from 'react'

export const SliderRail = forwardRef<HTMLSpanElement, SliderRailSlotProps>(
  function SliderRail(props, ref) {
    const {
      className,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- variable is not needed for rendering
      ownerState,
      ...rest
    } = props

    return (
      <span className={clsx('slider__rail', className)} ref={ref} {...rest} />
    )
  },
)
